import { Page, Text, Image, View } from "@react-pdf/renderer";
import ContractStyles from "../styles/contractStyles";
import Logo from "../../../../../../assets/images/logo/HorizontalLogo.png";
import FooterGraphic from "../../assets/images/CoverPageGraphic.png";
import { height } from "@mui/system";

const CoverPage = ({ contractName, adviserName, ARName }) => {
  const styles = ContractStyles();
  return (
    <Page size="A4" style={[styles.page, styles.py_lg, styles.px_xxl]}>
      <Image src={Logo} style={styles.headerlogo} />
      <Image src={FooterGraphic} style={styles.footerGraphic} />

      <View
        style={[
          styles.flexRow,
          styles.spaceBetween,
          styles.alignCenter,
          styles.gap_md,
          { top: "30%", position: "absolute" },
        ]}
      >
        <View
          style={[
            styles.flex,
            styles.bg_primary,
            styles.height_100,
            { width: 12 },
          ]}
        />
        <View
          style={[
            styles.flexColumn,
            styles.alignStart,
            styles.justifyCenter,
            styles.textLeft,
            styles.mt_xxl,
            styles.gap_xs,
          ]}
        >
          <Text style={[styles.serif_h4]}>{contractName}</Text>
          <View
            style={[
              styles.flexColumn,
              styles.alignStart,
              styles.justifyCenter,
              styles.textLeft,
              styles.mt_xxl,
              styles.gap_lg,
            ]}
          >
            <Text style={[styles.serif_h1, styles.text_primary]}>
              Rosemount Financial Solutions (IFA) Ltd
            </Text>
            <Text style={[styles.serif_h3]}>Contract for Services</Text>
            {(adviserName || ARName) &&
              (adviserName && ARName ? (
                <View
                  style={[
                    styles.flexRow,
                    styles.alignStart,
                    styles.justifyCenter,
                    styles.gap_sm,
                  ]}
                >
                  <Text style={[styles.serif_h2]}>{adviserName}</Text>
                  <View
                    style={[
                      styles.flex,
                      styles.bg_primary,
                      styles.height_100,
                      styles.alignStart,
                      { width: 5 },
                    ]}
                  />
                  <Text style={[styles.serif_h2]}>{ARName}</Text>
                </View>
              ) : (
                <Text style={[styles.serif_h2]}>{adviserName || ARName}</Text>
              ))}
          </View>
        </View>
      </View>
    </Page>
  );
};

export default CoverPage;
